module.exports = __webpack_public_path__ + "fonts/trust_sans_regular-webfont.78743d97.woff";